import { forwardRef, type Ref, type SVGProps } from "react";
const IconEntertainmentFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.925 9.3A1.838 1.838 0 0 1 22.7 7.075c.132-.537.169-1.177-.222-1.568l-1.893-1.893a1.84 1.84 0 0 0-2.6 0l-14.37 14.37a1.84 1.84 0 0 0 0 2.6l1.893 1.894c.39.39 1.03.353 1.567.222A1.838 1.838 0 0 1 9.3 24.925c-.131.536-.169 1.177.222 1.567l1.893 1.893a1.84 1.84 0 0 0 2.6 0l14.37-14.37a1.84 1.84 0 0 0 0-2.6l-1.892-1.893c-.39-.39-1.031-.354-1.568-.222m-6.916 4.144c.22-.07.389-.047.487.051.098.099.121.268.046.482l-.604 1.86 1.07 1.549c.257.378.094.705-.368.725l-1.92.08-1.212 1.567c-.205.266-.444.306-.614.136a.7.7 0 0 1-.153-.271l-.584-1.788-1.778-.574a.7.7 0 0 1-.271-.153c-.17-.17-.13-.409.136-.614l1.568-1.211.08-1.92c.016-.467.342-.63.724-.369l1.538 1.06z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconEntertainmentFilledSVG);
ForwardRef.displayName = "IconEntertainmentFilled";
export { ForwardRef as IconEntertainmentFilled };
